<template>
  <div class="header-top">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="left-top">
            <ul>
              <li>
                <i class="fas fa-map-marker-alt top-icon"></i> 237, Dschang,
                Cameroun
              </li>
              <li>
                <i class="fas fa-phone-volume top-icon"></i> +237 654-924-831
              </li>
              <li>
                <i class="fas fa-envelope top-icon"></i>
                <a
                  href="mailto:contact@eparchemin.com"
                  class="__cf_email__"
                  data-cfemail="bad7dbd3d6fac3d5cfc8ded5d7dbd3d494d9d5d7"
                  >contact@eparchemin.com</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-4">
          <div class="right-top">
            <ul>
              <li>
                <a href="https://www.facebook.com/eparchemin" target="_blank"
                  ><i class="fab fa-facebook"></i
                ></a>
              </li>
              <li>
                <a href="https://www.instagram.com/eparchemin" target="_blank"
                  ><i class="fab fa-instagram"></i
                ></a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/eparchemin/"
                  target="_blank"
                  ><i class="fab fa-linkedin-in"></i
                ></a>
              </li>

              <li>
                <a
                  href="https://www.youtube.com/channel/UCjPA7lt-m9W74JcA39bMR-Q"
                  target="_blank"
                  ><i class="fab fa-youtube"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <header class="header">
    <nav
      class="navbar navbar-expand-lg navbar-light bg-light pl-2 pr-2 sticky-top"
    >
      <router-link :to="{ name: 'Home' }" class="navbar-brand menu-logo">
        <img
          :src="require('@/assets/img/logos/logo.png')"
          class="img-fluid"
          alt="Logo"
        />
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li
            class="nav-item navbar-course"
            title="Cliquez pour aller a la page des cours "
          >
            <router-link
              class="nav-link text-primary"
              :to="{ name: 'Courses' }"
            >
              <u>{{ $t("Navbar.COURSES") }}</u>
            </router-link>
          </li>
        </ul>
        <form class="form-inline my-2 my-lg-0 nav-form">
          <i class="fas fa-search search-icon h3 text-muted"></i>
          <input
            class="form-control mr-sm-2 search-input"
            type="search"
            placeholder="Search"
            aria-label="Search"
          />
        </form>

        <div class="navbar-nav ml-auto">
          <label class="m-auto font-weight-bold pt-1 currency">{{
            $t("Navbar.CURRENCY")
          }}</label>
          <select
            class="form-control border-0 bg-light"
            v-model="test"
            @change="set($event)"
          >
            <option
              @click="() => setDefaultCurrency('XAF')"
              value="XAF"
              :selected="$store.state.defaultCurrency == 'XAF'"
            >
              FCFA CEMAC
            </option>
            <option
              @click="() => setDefaultCurrency('XOF')"
              value="XOF"
              :selected="$store.state.defaultCurrency == 'XOF'"
            >
              FCFA CEDEAO
            </option>
          </select>
        </div>
        <ul v-if="!userIsLoged" class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link
              class="nav-link btn btn-sm login-link ml-2"
              :to="{ name: 'Login' }"
              ><i class="fas fa-sign-in-alt"></i> Login</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link btn btn-sm register-link btn-primary ml-2"
              to="/register"
              ><span class="fas fa-registered"></span> Register</router-link
            >
          </li>
        </ul>
        <ul v-else class="navbar-nav ml-auto">
          <li class="nav-item dropdown has-arrow logged-item">
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <span class="user-img">
                <img
                  class="rounded-circle mr-2"
                  :src="avatar"
                  width="31"
                  alt="Darren Elder"
                />{{ logedUser.firstName }} {{ logedUser.lastName }}
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right">
              <div class="user-header">
                <div class="avatar avatar-sm">
                  <img
                    :src="avatar"
                    alt="User Image"
                    class="avatar-img rounded-circle"
                  />
                </div>
                <div class="user-text">
                  <h6>{{ logedUser.email }}</h6>
                  <p class="text-muted mb-0">{{ logedUser.groups }}</p>
                </div>
              </div>
              <router-link
                v-if="
                  $store.getters.userGroup === 'student' ||
                  $store.getters.userGroup === 'teacher'
                "
                class="dropdown-item"
                :to="{ name: 'Dashboard' }"
                >Dashboard</router-link
              >
              <a
                v-if="$store.getters.userGroup === 'admin'"
                target="_blank"
                href="#"
                @click.prevent="redirectToAdmin"
                class="dropdown-item"
                >Administration</a
              >
              <router-link
                class="dropdown-item"
                :to="{ name: 'ProfileSettings' }"
                >Profile Settings</router-link
              >
              <router-link :to="{ name: 'Logout' }" class="dropdown-item"
                >Logout</router-link
              >
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { ADMIN_HOST, APIUrl } from "../../http";

export default {
  name: "Navbar",

  data() {
    return {
      categories: [],
      dataCatégorie: [],
      CourseInCategorie: [],
      test: this.$store.state.defaultCurrency,
      userIsLoged: localStorage.getItem("access") != null,
      avatar:
        "data:image/png;base64,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",
    };
  },
  methods: {
    ShowAllCourseCategory(id) {
      this.$router.push({ name: "ShowCourseCategory", params: { idCat: id } });
    },
    ShowAllCourseCategorie(id) {
      this.CourseInCategorie = [];
      this.$nextTick(function () {
        this.$http
          .get("courses/category/" + id + "/")
          .then((res) => (this.CourseInCategorie = res.data));
      });
    },
    async loadCathegories() {
      await this.$store
        .dispatch("loadAllCathegoriesCourses")
        .then((categories) => (this.categories = categories));
    },
    setDefaultCurrency(c) {
      localStorage.setItem("currency", c);
    },
    set(e) {
      var devise = e.target.value;
      localStorage.setItem("currency", devise);
      location.reload();
    },
    redirectToAdmin() {
      const refresh = localStorage.getItem("refresh");
      if (refresh != null && refresh.length > 30) {
        window.open(ADMIN_HOST + "/auth/" + refresh, "_blank");
      } else {
        this.$toast.error(
          "Vous n'avez plus de Jeton pour l'administration, veillez vous rauthentifier!"
        );
      }
    },
  },
  computed: {
    logedUser() {
      return this.$store.state.logedUser;
    },
  },

  beforeMount() {
    this.$nextTick(function () {
      const user = localStorage.getItem("srtingifiedUser");
      if (user != null) {
        let image = JSON.parse(user).profilePicture.thumbnail;
        if (!image.includes("http")) {
          this.avatar = APIUrl + image;
        } else {
          this.avatar = image;
        }
      }
      this.loadCathegories();
    });
  },
};
</script>

<style scoped>
.search-input {
  padding-left: 50px !important;
  border-radius: 50px;
}
.nav-form {
  position: relative;
}
.search-icon {
  position: absolute;
  top: 8px;
  left: 15px;
}
.router-link-active {
  color: #009da6 !important;
}
.logo {
  width: 60px;
  margin-bottom: 3px;
  height: 60px;
  border-radius: 50%;
}
.login-link,
.register-link {
  color: white !important;
  border-radius: 0 !important;
}
.login-link {
  background-color: #ff9c27 !important;
}

.navbar-light .navbar-nav .nav-link {
  color: #000;
  font-size: 16px;
  font-weight: bold;
}
.menu-logo img {
  height: 50px;
  border-radius: 50%;
  width: 50px;
}
@media only screen and (max-width: 750px) {
  .navbar-course {
    font-size: 21px;
    font-weight: 900;
    text-align: center;
  }

  .navbar-nav {
    border-bottom: solid 0.5px rgb(175, 170, 170);
  }
  .nav-form {
    border-bottom: solid 0.5px rgb(175, 170, 170);
    padding-bottom: 9px !important;
  }
  .currency {
    display: none;
  }
}
</style>
